var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-testid": "cap-setting" } },
    [
      _c("Field", {
        attrs: {
          label: _vm.enableCapsLabel,
          "has-tooltip": true,
          "tooltip-text": _vm.enableCapsTooltip
        },
        scopedSlots: _vm._u([
          {
            key: "element",
            fn: function() {
              return [
                _c("ValidationProvider", { attrs: { slim: "" } }, [
                  _c(
                    "div",
                    { staticClass: "col-md-8 col-sm-8" },
                    [
                      _c("NzToggle", {
                        attrs: {
                          "data-testid": "cap-setting-toggle-caps",
                          disabled: _vm.readonly
                        },
                        on: { onToggle: _vm.handleEnableCapSettingsChange },
                        model: {
                          value: _vm.showCaps,
                          callback: function($$v) {
                            _vm.showCaps = $$v
                          },
                          expression: "showCaps"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.showCaps
        ? _c(
            "div",
            { attrs: { "data-testid": "cap-setting-caps-wrapper" } },
            _vm._l(_vm.capSettings, function(cap, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t(_vm.capFieldsTranslation[cap.key].label, {
                        capCriteria: _vm.translationDictionary["capCriteria"]
                      }),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t(
                        _vm.capFieldsTranslation[cap.key].tooltip,
                        {
                          capCategory: _vm.translationDictionary["capCategory"]
                        }
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c(
                                "ValidationProvider",
                                { attrs: { slim: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-3 col-sm-2 col-md-2 col-lg-2 toggle-wrap"
                                    },
                                    [
                                      _c("NzToggle", {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          "data-testid": `cap-setting-${cap.key}`,
                                          value: _vm.parseBoolean(cap.model)
                                        },
                                        on: {
                                          onToggle: function($event) {
                                            return _vm.onToggle(cap.key, $event)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  cap.model > -1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-4 col-sm-2 col-md-1 col-lg-2"
                                        },
                                        [
                                          cap.capSettingType ===
                                          _vm.capSettingType.SUM
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "currency currency-with-toggle",
                                                  attrs: {
                                                    "data-testid":
                                                      "cap-setting-prefix"
                                                  }
                                                },
                                                [_vm._v("$")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "form-control m-b-0",
                                            attrs: {
                                              "data-testid":
                                                "cap-setting-cap-field-input",
                                              type: "number",
                                              min: "0",
                                              step: "0.01",
                                              readonly: _vm.readonly
                                            },
                                            domProps: {
                                              value: cap.modelSettings
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.onSetCapField(
                                                  cap.key,
                                                  +$event.target.value
                                                )
                                              },
                                              wheel: function($event) {
                                                return $event.target.blur()
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cap.model < 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-3 col-sm-7 col-md-3 form-control-static",
                                          attrs: {
                                            "data-testid": "cap-setting-none"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("NONE_TEXT")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cap.model === 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-3 col-sm-7 col-md-3 form-control-static"
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("CLOSED")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }